'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getAddFavoritesHref = function getAddFavoritesHref(redirectUrl) {
  var query = redirectUrl ? '?redirectUrl=' + encodeURIComponent(redirectUrl) : '';
  return '/setup/favorite-surf-spots' + query;
};

exports.default = getAddFavoritesHref;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/getAddFavoritesHref.js
// module id = 187
// module chunks = 0